import clsx from 'clsx'
import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import type { PelaksanaanSchool } from 'types/kinerja-pelaksanaan'

interface CardSchoolProps {
  school: PelaksanaanSchool
  baseHref: string
  ctaText: string
  ctaLabel?: string
  checkConfirmation?: boolean
  fullWidth?: boolean
  onClick?: () => void
}

export const CardSchool = ({
  school,
  ctaText,
  baseHref,
  checkConfirmation = true,
  fullWidth = false,
  ctaLabel,
  onClick,
}: CardSchoolProps) => {
  return (
    <div
      className={clsx(
        'border border-gray-20 rounded-lg p-6 flex gap-2 justify-between items-start',
        fullWidth && 'w-full'
      )}
    >
      <div className="gap-1">
        <Text
          variant="heading-sm"
          className="line-clamp-2 overflow-wrap-anywhere"
        >
          {school.schoolName}
        </Text>
        <Text color="subdued" className="overflow-wrap-anywhere">
          {school.npsn}
        </Text>
        <Text color="subdued">
          {school.role == 'KS_DEFINITIF'
            ? 'Kepala Sekolah Definitif'
            : 'Plt. Kepala Sekolah'}
        </Text>
        {school.submitGuruAdditional && (
          <div className="flex items-center gap-1 mt-1">
            <Icon color="critical">warning</Icon>
            <Text color="critical">Lakukan Penilaian Susulan.</Text>
          </div>
        )}
        {school.confirmationStatus === 'UNCONFIRMED' && checkConfirmation && (
          <div className="flex items-center gap-1 mt-1">
            <Icon color="critical">warning</Icon>
            <Text color="critical">Perlu konfirmasi data.</Text>
          </div>
        )}
        {school.confirmationStatus === 'REJECTED' && checkConfirmation && (
          <Text color="critical">Ulangi konfirmasi data.</Text>
        )}
      </div>
      {school.confirmationStatus === 'REJECTED' ? (
        <Button color="white" className="whitespace-nowrap" onClick={onClick}>
          Konfirmasi Data
        </Button>
      ) : (
        <Link href={`${baseHref}/${school.npsn}`} passHref>
          <Button
            as="a"
            disabled={
              school.confirmationStatus == 'UNCONFIRMED' && checkConfirmation
            }
            aria-label={ctaLabel}
            type={undefined}
            color="black"
            size="lg"
            className="whitespace-nowrap"
            onClick={onClick}
          >
            {ctaText}
          </Button>
        </Link>
      )}
    </div>
  )
}
